export class CompraIntegracaoExcluirRequest {
  justificativa = '';
}
